export type AgreementSaveResult = { saved: boolean; id: string | null };

/**
 * Salva os dois ou nada (AF-4057, R6): grava o acordo de cobrança e, só com ele gravado, a operação com o
 * `collection_agreement_id` devolvido. Devolve se a operação foi enviada.
 */
export const submitWithAgreement = async (
    saveAgreement: () => Promise<AgreementSaveResult>,
    saveOperation: (agreementId: string | null) => Promise<void>,
): Promise<boolean> => {
    const agreement = await saveAgreement();
    if (!agreement.saved) return false;
    await saveOperation(agreement.id);
    return true;
};
